import { createElement, styled, display, space } from '@vebox/etui-system';

const HeaderElement = createElement('header');
const Header = styled(HeaderElement)`
  ${display};
  ${space};
`;

export { Header };
